import { api } from "../api";

/**
 * deleteGroupByIdAndCustomerAndDepartment - Function that deletes on database an existing group  
 * /groups/{customerId}/{departmentId}/{id}  
 * method DELETE  
 * Do not use (disabled function)
 * @async-function
 */
const deleteGroupByIdAndCustomerAndDepartment = async (token: string, customerId: number, departmentId: number, id: number) => {
    const response = await api.delete(
        `/groups/${customerId}/${departmentId}/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
         }
    );
    return response;
};

export default deleteGroupByIdAndCustomerAndDepartment;